<div class="main-div plan-instructions ml-5">
  <div>
    <p>Insira os dados do cartão de crédito para efetuar a compra no valor de <strong>R$ {{ selectedData.price }}.</strong>
      O sistemareconhecerá automaticamente o pagamento em um periodo entre <strong>30 à 60 segundos</strong>. Bons estudos!
    </p>
  </div>
</div>

<form
  [formGroup]="cardInfoForm"
  (ngSubmit)="onSubmit()"
  class="center-form"
>
  <mat-form-field appearance="outline">
    <mat-label>Nome no Cartão</mat-label>
    <input matInput formControlName="name">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Número do Cartão</mat-label>
    <input matInput formControlName="number" mask="0000 0000 0000 0000">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Mês</mat-label>
    <input matInput formControlName="month" mask="00">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Ano</mat-label>
    <input matInput formControlName="year" mask="0000">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>CVV</mat-label>
    <input matInput formControlName="cvv" mask="000">
  </mat-form-field>

  <button mat-raised-button color="primary">Finalizar compra</button>
</form>
